import breakpoints from './breakpoints'
import buttons from './buttons'
import colors from './colors'
import fonts from './fonts'
import forms from './forms'
import fontSizes from './fontSizes'
import fontWeights from './fontWeights'
import text from './text'
import shadows from './shadows'
import space from './space'
import variants from './variants'

const Theme = {
    breakpoints,
    buttons,
    colors,
    fonts,
    fontSizes,
    fontWeights,
    forms,
    shadows,
    space,
    text,
    variants
}
export default Theme